import { render } from "./PageHeaderImage.vue?vue&type=template&id=0d17ba40"
import script from "./PageHeaderImage.vue?vue&type=script&lang=js"
export * from "./PageHeaderImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__